export default __webpack_public_path__ + "static/media/diagram.1eca1c7a.png";